<template>
  <v-sheet class="mb-3" elevation="6">
      <v-navigation-drawer expand-on-hover rail @update:rail="updateRail" rail-width="60" width="300" permanent location="right" style="border: none;" elevation="5">
          <v-list class="d-flex flex-column justify-space-between" style="height: 100%;">
            <div style="height: 100%; overflow-y: auto; overflow-x: hidden;">
              <span v-for="category in navContent">
                <span v-for="item in category">
                  <router-link :to="item.path" style="text-decoration:none">
                    <v-list-item link :color="item.color" :active="$route.path == item.path" density="compact">
                      <template v-slot:prepend>
                        <v-icon :color="item.color">{{ item.icon }}</v-icon>
                      </template>
                      <v-list-item-title>
                        <h3 :class="$route.path != item.path ? 'text-secondary' : ('text-'+item.color)" v-text="item.title"></h3>
                      </v-list-item-title>
                    </v-list-item>
                  </router-link>
                </span>
                <div class="my-2">
                  <v-divider></v-divider>
                </div>
              </span>
            </div>
          </v-list>
      </v-navigation-drawer>
  </v-sheet>
</template>

<script>
import navItems from "@/data/navItems.js";
import { getAuth,  } from '@firebase/auth'
import { useProfileStore } from '@/stores/profile'

export default {
  setup() {
      return {
          navItems,
          store: useProfileStore()
      }
  },
  data() {
    return {
      unsub: [],
      isOpen: true,
      isDeploy: false,
    }
  },
  computed: {
    navContent() {
      let nav = []
      
      if(!this.store.profile) {
        return nav
      }

      navItems.forEach(cat => {
        let items = []

        cat.forEach(item => {
          let itemRoute = this.$router.resolve({ path: item.path })
          
          let visible = true
          if(!this.store.profile || this.store.profile.role == 'User') {
            visible = false
          }
          if(itemRoute.meta.accessRules.devNeeded && !this.store.profile.dev) {
            visible = false
          }
          if(itemRoute.meta.accessRules.accountNeeded && itemRoute.meta.accessRules.roleNeeded.includes('User')){
            visible = false
          }

          if(visible) {
            item.dev = itemRoute.meta.accessRules.devNeeded

            if(itemRoute.meta.accessRules.roleNeeded.includes('Admin')){
              item.superAdminOnly = false
            }else if(itemRoute.meta.accessRules.roleNeeded.includes('SuperAdmin')){
              item.superAdminOnly = true
            }

            item.name = itemRoute.name
            item.title = itemRoute.meta.title
            
            items.push(item)
          }
        })

        if (items.length > 0) {
          nav.push(items)
        }
      })

      return nav
    }
  },
  methods: {
      updateRail(e) {
        this.isDeploy = !e;
      },
      logout(){
        getAuth().signOut()
        this.$router.push('/login')
      },
  },
}

</script>